/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   ul[_ngcontent-%COMP%]{margin:0 0 5px;display:flex}[_nghost-%COMP%]   li[_ngcontent-%COMP%]{font-size:12px;margin-right:2px;padding:0 3px;background:#f5f5fa;border-bottom:2px solid #f5f5fa;border-radius:2px;cursor:pointer}[_nghost-%COMP%]   li.current[_ngcontent-%COMP%]{border-bottom:2px solid #0096dc}"];
export { styles as styles };
